(function() {
    window.showMakesafePopup = function() {};

    // Move makesafe promo header to top
    if ($('div[data-shopify-editor-section]').length == 0) {
        var tmp1 = $('body[data-section-type="main-body"] #shopify-section-makesafe-header-promo-announcement').detach().removeClass('shopify-section');
        if (tmp1.length > 0) {
            tmp1.find('.promo-announcement-root').removeAttr('data-section-id');
            tmp1.prependTo($('body[data-section-type="main-body"] #shopify-section-header .header-toolbar'));
        }
    }

    var $headerImages = $('#makesafe-header-collection-images-makesafe-collection-header-images');
    if ($headerImages.length > 0) {
        var collectionImageMapping = JSON.parse($headerImages.html());
        if (collectionImageMapping.length > 0) {
            var image = collectionImageMapping[0].image;
            $('.collection .background-colored').css('background', 'url(' + image + ') center center no-repeat');
        }
    }

    $('.makesafe-sticky').each(function(i, item) {
        $(item).closest('.shopify-section').addClass('sticky-section');
    });

    var updateTopSticky = function() {
        var collectionsBreadcrumbs = $('#shopify-section-collection-template .container .sorting');
        if (collectionsBreadcrumbs.length > 0) {
            setTimeout(function() {
                var top = $('#content.collection-page').offset().top;
                collectionsBreadcrumbs.css('top', top);
            }, 5);
        }

        var topHeader = 0;
        $('#shopify-section-header, #shopify-section-header-announcement:visible').each(function(i, it) {
            topHeader += $(it).height();
        });
        //$('#shopify-section-makesafe-header-promo-announcement').css('top', topHeader);

        topHeader = 0;
        $('#shopify-section-header, #shopify-section-header-announcement:visible, #shopify-section-makesafe-header-promo-legacy:visible').each(function(i, it) {
            topHeader += $(it).height();
        });
        $('.sticky-section').css('top', topHeader);
    };

    window.onresize = updateTopSticky;
    $(function() {
        updateTopSticky();
    });

    var discount = null;
    var discounts = [];

    var deferredCalls = [];

    // This is for product page where theme is handling all the substitutions based on #ProductJson-product-template
    var originalProductOptions = theme.product_options;
    theme.product_options = function($container, calledAsDeferred) {
        if (!discount || discounts.length > 1) {
            if (!calledAsDeferred)
                originalProductOptions($container);

            deferredCalls.push(function() { theme.product_options($container, true); });
            return;
        }
            
        var productJson = JSON.parse($('#ProductJson-product-template').html());

        productJson.price = getDiscountedPrice(productJson.price, productJson.id);
        productJson.price_max  = getDiscountedPrice(productJson.price_max, productJson.id);
        productJson.price_min = getDiscountedPrice(productJson.price_min, productJson.id);

        if (!discount.show_savings) {
            productJson.compare_at_price = getDiscountedPrice(productJson.compare_at_price, productJson.id);
            productJson.compare_at_price_max = getDiscountedPrice(productJson.compare_at_price_max, productJson.id);
            productJson.compare_at_price_min = getDiscountedPrice(productJson.compare_at_price_min, productJson.id);
        }

        (productJson.variants || []).forEach(variant => {
            variant.price = getDiscountedPrice(variant.price, productJson.id);
            if (!discount.show_savings) {
                variant.compare_at_price = getDiscountedPrice(variant.compare_at_price, productJson.id);
            }
        });

        $('#ProductJson-product-template').html(JSON.stringify(productJson));

        if (!calledAsDeferred)
            originalProductOptions($container);
        else {
            $container.find('select[id^="product-select-product-template-option"]').trigger('change');
        }
    };

    var decodedCookies = decodeURIComponent(document.cookie).split(';').map(v => v.trim().split('='));
    var readCookie = function(name) {
        var c = decodedCookies.filter(v => v[0] == name);
        if (c && c.length > 0) {
            if (c[0].length > 1) {
                return c[0][1];
            }
        }

        return null;    
    }

    var getDiscountCode = function() {
        return readCookie('discount_code');
    }

    var getDiscountedPrice = function(price, product_id) {
        product_id = parseInt(product_id);

        var discountToApply = discounts.length > 0 ? discounts[0] : null;
        if (product_id > 0) {
            // find discount that applies to this product, each discount has an array of product ids
            discounts.forEach(function(d) {
                if (d.product_ids && d.product_ids.indexOf(product_id) != -1) {
                    discountToApply = d;
                }
            });
        }

        if (discountToApply) {
            if (discountToApply && discountToApply.type == '%') {
                return Math.ceil(price * (100 - discountToApply.parsedValue)/100);
            } else {

            }
        }
    }

    var clearRequested = readCookie('makesafe-referrer-clear') == 'clear';
    if (clearRequested) {
        document.cookie = 'makesafe-referrer-clear=x;path=/;domain=.makesafe.com;expires=Thu, 01 Jan 1970 00:00:01 GMT';
        document.cookie = 'makesafe-referrer=x;path=/;domain=.makesafe.com;expires=Thu, 01 Jan 1970 00:00:01 GMT';
        document.cookie = 'discount_code=x;path=/;expires=Thu, 01 Jan 1970 00:00:01 GMT';

        window.localStorage.removeItem('makesafe-impressions');
        window.localStorage.removeItem('makesafe-discount');
        window.localStorage.removeItem('makesafe-last-impression');
        window.localStorage.removeItem('makesafe-version');
    }

    var discount_code = getDiscountCode();
    var discountCodesParam = null;

    var updateDiscountLinkInForms = function() {
        if (!discountCodesParam)
            return;

        var forms = $('form.makesafe-cart-apply-discounts');
        if (forms.length > 0) {
            forms.each(function(idx, form) {
                form = $(form);
                if (form.attr('action').indexOf('discount=') == -1) {
                    if (form.attr('action').indexOf('?') == -1)
                        form.attr('action', form.attr('action') + '?discount=' + discountCodesParam);
                    else
                       form.attr('action', form.attr('action') + '&discount=' + discountCodesParam);
                }
            });
        }

    };

    var referrer = readCookie('makesafe-referrer');
    if (referrer) {
        $('.makesafe-hide-if-cookie').hide();
        $('.makesafe-show-if-cookie').show();

        var processInfoResponse = function(info) {
            var promoDiv = $('#shopify-section-makesafe-header-promo-announcement .promo-announcement-root');

            var showPopup = function() {
                var promoModal = promoDiv.find('.announcement-modal');
                promoModal.find('.body').html(info.popup.html || "");
                var fancyGreeting = promoModal.html();
                setTimeout(function() {
                    $.fancybox.open([ fancyGreeting ], {
                        beforeLoad: function(slide) {
                            $(slide.$refs.container).addClass('makesafe-promo-popup');
                        },
                        afterLoad: function(slide) {
                            $(slide.$refs.container).find('.fancybox-content').css('max-width', info.popup.width);
                            if (info.popup.script) {
                                promoDiv.append(info.popup.script);
                            }
                        }
                    });
                }, 0);
            };

            var showHeader = function() {
                window.showMakesafePopup = showPopup;

                promoDiv.find('.promo-announcement').html(info.header.html);
                promoDiv.show();

                setTimeout(function() {
                    var topHeader = 0;
                    $('#shopify-section-header, #shopify-section-header-announcement:visible').each(function(i, it) {
                        topHeader += $(it).height();
                    });
                    //$('#shopify-section-makesafe-header-promo-announcement').css('top', topHeader);
                    updateTopSticky();
                }, 0);
            };

            var getLocal = function(name) {
                return localStorage.getItem(name);
            };
            var setLocal = function(name, value) {
                localStorage.setItem(name, value);
            }
            var getSession = function(name) {
                return sessionStorage.getItem(name);
            }
            var setSession = function(name, value) {
                sessionStorage.setItem(name, value);
            }

            var localVersion = getLocal('makesafe-version') || 1;
            var localImpressions = parseInt(getLocal('makesafe-impressions')) || 0;
            var localLastImpressionTime = parseInt(getLocal('makesafe-last-impression')) || 0;
            var localLastDiscount = getLocal('makesafe-discount') || '';
            var localLastImpressionCount = parseInt(getLocal('makesafe-last-impression-count')) || 0;

            var sessionImpressions = parseInt(getSession("makesafe-session-impressions")) || 0;

            var now = Date.now() / 1000;

            var shouldShow = 1;
            if (info.version != localVersion || localLastDiscount != (info.discount ? info.discount.name : '')) {
                localImpressions = 1;
                sessionImpressions = 1;
                setLocal('makesafe-impressions', 1);
                setLocal('makesafe-discount', info.discount ? info.discount.name : '');
                setLocal('makesafe-last-impression', now);
                setLocal('makesafe-last-impression-count', 1);
                setSession('makesafe-session-impressions', 1);
                
                localImpressions = parseInt(getLocal('makesafe-impressions')) || 0;
                localLastImpressionTime = parseInt(getLocal('makesafe-last-impression')) || 0;
                localLastDiscount = getLocal('makesafe-discount') || '';
    
                showShow = 1;
            } else {
                var blockedImpression = info.popup.allowed_paths ? (info.popup.allowed_paths.indexOf(window.location.pathname) == -1) : false;

                if (!blockedImpression) {
                    var repeatEvery = info.popup.repeat_every_x_page_views;
                    if (repeatEvery == -1) // show only once
                        shouldShow = localImpressions == 0;
                    else if (repeatEvery == 0) // never show
                        shouldShow = 0;
                    else if (repeatEvery > 0) {
                        localImpressions = localImpressions + 1;
                        if ((localImpressions - localLastImpressionCount) >= repeatEvery) {
                            if (!info.popup.show_only_once_per_session || sessionImpressions == 0) {
                                shouldShow = 1;
                                setLocal('makesafe-last-impression', now);
                                setLocal('makesafe-last-impression-count', localImpressions);
                                setSession('makesafe-session-impressions', sessionImpressions + 1);
                            } else
                                shouldShow = 0;
                        } else
                            shouldShow = 0;

                        setLocal('makesafe-impressions', localImpressions);
                    }

                    var repeat_every_x_seconds = info.popup.repeat_every_x_seconds || 0;
                    repeat_every_x_seconds += (info.popup.repeat_every_x_minutes || 0) * 60;
                    repeat_every_x_seconds += (info.popup.repeat_every_x_hours || 0) * 60 * 60;
                    repeat_every_x_seconds += (info.popup.repeat_every_x_days || 0) * 60 * 60 * 24;
                    repeat_every_x_seconds += (info.popup.repeat_every_x_weeks || 0) * 60 * 60 * 24 * 7;

                    if (repeat_every_x_seconds > 0) {
                        if ((now - localLastImpressionTime) >= repeat_every_x_seconds) {
                            if (!info.popup.show_only_once_per_session || sessionImpressions == 0) {
                                shouldShow = 1;

                                localImpressions = localImpressions + 1;
                                setLocal('makesafe-impressions', localImpressions);
                                setLocal('makesafe-last-impression', now);
                                setLocal('makesafe-last-impression-count', localImpressions);
                                setSession('makesafe-session-impressions', sessionImpressions + 1);
                            } else
                                shouldShow = 0;
                        }
                    }
                } else {
                    shouldShow = 0;
                }
            }

            if (promoDiv.length == 0)
                shouldShow = 0;

            if (info.discounts) {
                discounts = info.discounts;
            } else if (info.discount && info.discount.name) {
                discounts = [info.discount];
            }
                
            if (discounts.length > 0) {
                var placesToAddDiscountInputs = $('.makesafe-cart-apply-discounts');

                discountCodesParam = discounts.map(function(d) { return d.name; }).join(',');
                updateDiscountLinkInForms();

                for (var i = 0; i < discounts.length; i++) {
                    var local_discount = discounts[i];

                    var applyJustTheDiscount = i > 0;

                    var canDisplayInfo = shouldShow;
                    if (discount_code) {
                        discount_code = local_discount.name;
    
                        canDisplayInfo = (discount_code != local_discount.name) || (shouldShow);

                    }
    
                    // placesToAddDiscountInputs.each(function(idx, item) {
                    //     var $item = $(item);
                    //     var discountInput = $('<input type="hidden" name="discount" value="' + local_discount.name + '">');
                    //     $item.append(discountInput);
                    // });

                    if (i == 0 && discount_code != local_discount.name && discounts.length == 1) {
                        var canDisplayInfoInner = canDisplayInfo;
                        $.get('/discount/' + local_discount.name, function(data) {
                            if (canDisplayInfoInner)
                                showPopup();
        
                            if (info.header.html)
                                showHeader();
                        });
                    } else if (i == 0) {
                        if (canDisplayInfo)
                            showPopup();

                        if (info.header.html)
                            showHeader();                        
                    }
                }
            } else {
                if (shouldShow) {
                    showPopup();
                    if (info.header.html)
                        showHeader();
                } else {
                    setTimeout(updateTopSticky, 0);
                }

                discount_code = null;
            }

            // if (!discount_code)
            //     return;
            
            discount = info.discount;
            discount.parsedValue = parseFloat(discount.value);
            discounts.forEach(function(d) {
                d.parsedValue = parseFloat(d.value);
            });

            // run all deferred calls
            while (call = deferredCalls.pop()) {
                console.log('calling deferred')
                call();
            }

            $(function() {
                if (discounts.length > 1) {
                    return; // disable updating prices
                }

                // Update prices on collection pages / home page
        
                var productsJson = [];
                $('script[id^="ProductsJson-"]:not(#ProductJson-product-template)').each(function(idx, item) {
                    var itemsJson = JSON.parse($(item).html());
                    if (itemsJson.length > 0 && Array.isArray(itemsJson[0])) {
                        itemsJson = itemsJson.reduce(function(acc, i) {
                            return acc.concat(i);
                        });
                    }
        
                    productsJson = [...productsJson, ...itemsJson];
        
                });

                if (productsJson.length > 0) {
                    productsJson.forEach(function(product) {
                        var productDetails = $('[id="makesafe-product-' + product.id + '"]');
                        productDetails.find('.makesafe-price').each(function(idx, item) {
                            console.log(1, product.price, getDiscountedPrice(product.price, product.id));
                            $(item).html(Shopify.formatMoney(getDiscountedPrice(product.price, product.id), theme.moneyFormat));
                        });
                        productDetails.find('.makesafe-pricemax').each(function(idx, item) {
                            console.log(2, product.price_max, getDiscountedPrice(product.price_max, product.id));
                            $(item).html(Shopify.formatMoney(getDiscountedPrice(product.price_max, product.id), theme.moneyFormat));
                        });

                        productDetails.find('.makesafe-compareprice del').each(function(idx, item) {
                            console.log(3, product.compare_at_price, getDiscountedPrice(product.compare_at_price, product.id));
                            $(item).html(Shopify.formatMoney(discount.show_savings ? (product.compare_at_price || product.price) : getDiscountedPrice(product.compare_at_price || product.price, product.id), theme.moneyFormat));
                            $(item).parent().show();
                        });

                        (product.variants || []).forEach(function(variant) {
                            productDetails.find('.makesafe-variantprice-' + variant.id).each(function(idx, item) {
                                console.log(4, variant.price, getDiscountedPrice(variant.price, product.id));
                                $(item).html(Shopify.formatMoney(getDiscountedPrice(variant.price, product.id), theme.moneyFormat));
                            });

                            productDetails.find('.makesafe-variantcompareprice-' + variant.id + " del").each(function(idx, item) {
                                console.log(5, variant.compare_at_price, getDiscountedPrice(variant.compare_at_price, product.id));
                                $(item).html(Shopify.formatMoney(discount.show_savings ? (variant.compare_at_price || variant.price) : getDiscountedPrice(variant.compare_at_price || variant.price, product.id), theme.moneyFormat));
                                $(item).parent().show();
                            });
                        });
                    });
                }
        
                // Update prices on /cart page
                var cartJsonTemplate = $('script[id^="CartJson-"]');
                if (cartJsonTemplate.length > 0) {
                    var cartJson = JSON.parse(cartJsonTemplate.html());
        
                    var cartTable = $('#cart-table');
                    if (cartTable.length > 0) {
                        var total_price = 0.0;
        
                        cartTable.find('div[id^="product-id-"]').each(function(idx, domItem) {
                            var $domItem = $(domItem);
                            var key = $domItem.attr('id').replace(/^product-id-/, '');
        
                            var lineItem = cartJson.items.filter(function(cartItem) {
                                return cartItem.key == key;
                            })[0];
        
                            var itemPrice = getDiscountedPrice(lineItem.original_line_price, key);
                            $domItem.find('.total-price-item').each(function(idx, item) {
                                //console.log(1, itemPrice);
                                //$(item).html(Shopify.formatMoney(itemPrice, theme.moneyFormat));
                            });;
                            $domItem.find('.price-field').each(function(idx, item) {
                                //console.log(2, itemPrice);
                                //$(item).html(Shopify.formatMoney(itemPrice, theme.moneyFormat) + ' each');
                            });;

                            total_price += itemPrice;
                        });

                        cartTable.find('#total-cart-top, #total-cart-bottom').each(function(idx, item) {
                            //console.log(3, total_price);
                            //$(item).html(Shopify.formatMoney(total_price, theme.moneyFormat));
                        });
                    }
        
                    updateTopRightCart(cartJson);
                }
            });

            var ajaxCartData = {};

            // Update prices in search
            $(document).ajaxSuccess(function(event, xhr, settings, data) {
                // if (settings.url.indexOf(theme.routes_search_url) == 0 && discounts.length <= 1) {
                //     domItems = $('.search-results .product-price h6');
                //     for (var i = 0; i < data.results.length; i++) {
                //         domItems.eq(i).html(Shopify.formatMoney(getDiscountedPrice(data.results[i].price), theme.moneyFormat));
                //     }
                // }

                if (Shopify && Shopify.AjaxifyCart) {
                    var config = Shopify.AjaxifyCart.getConfig();
        
                    if (settings.url == config.shopifyAjaxCartURL) {
                        ajaxCartData.data = data;
                    }
                    if (settings.url == window.location.toString()) {
                        ajaxCartData.updated = 1;
                    }
        
                    if (ajaxCartData.data && ajaxCartData.updated) {
                        setTimeout(function() {
                            updateTopRightCart(ajaxCartData.data);
                            ajaxCartData = {};
                        }, 0);
                    }
                }
            });

            setInterval(function() {
                updateDiscountLinkInForms();
            }, 1000);
        
            var updateTopRightCart = function(cartJson) {
                updateDiscountLinkInForms();

                if (discounts.length > 1) {
                    return; // disable updating prices
                }

                var total_price = 0.0;

                $('#cart-dropdown *[class^="total-item-"]').each(function(idx, domItem) {
                    var lineItem = cartJson.items[idx];
                    var itemPrice = getDiscountedPrice(lineItem.line_pricem, lineItem.product_id);
                    total_price += itemPrice;
        
                    $domItem = $(domItem);
                    //$domItem.html('total: ' + Shopify.formatMoney(itemPrice, theme.moneyFormat));
                    $domItem.closest('.item-row').find('.product-price h6').each(function(idx2, item) {
                        //$(item).html(Shopify.formatMoney(getDiscountedPrice(lineItem.price, lineItem.product_id), theme.moneyFormat) + ' each');
                    });
                });        

                $('.cartTotalSelector').each(function(idx, item) {
                    //$(item).html(Shopify.formatMoney(total_price, theme.moneyFormat));
                });
            }

            if (info.include) {
                var head = document.getElementsByTagName('head')[0];
                if (info.include.js) {
                    for (i = 0; i < info.include.js.length; i++) {
                        var s = document.createElement('script');
                        s.type = 'text/javascript';
                        s.async = true;
                        s.src = info.include.js[i];
                        head.appendChild(s);
                    }
                }

                if (info.include.css) {
                    for (i = 0; i < info.include.css.length; i++) {
                        var s = document.createElement('link');
                        s.rel = 'stylesheet';
                        s.type = 'text/css';
                        s.href = info.include.css[i];
                        head.appendChild(s);
                    }
                }
            }
        };

        var baseUrl = 'https://bkr.makesafe.com'; // 'https://bkr.' + window.location.host.replace(/(www|shop)\./, '');
        $.ajax({
            type: 'GET',
            url: baseUrl + '/client/' + referrer + '/info.json',
            headers: {
                'X-Makesafe': referrer
            }
        }).done(function(info) {
            processInfoResponse(info);
        });

    } else {
        updateTopSticky();        
    }

    $(function() {
        $('.makesafe-compareprice del:empty, .makesafe-variantcompareprice del:empty').each(function(i, el) {
            $(el).parent().hide();
        });
    })
})();
